const i18n = {
  title: 'Configuração da distribuição automática de atividades',
  description: 'Configure os parâmetros para a distribuição automática de atividades.',
  filters: 'Critérios',
  'filters.enable': 'Habilitar',
  'filters.distance': 'Distância',
  'filters.distance.description': 'Considera uma área de pesquisa.',
  'filters.schedule': 'Disponibilidade',
  'filters.schedule.description':
    'Procura por usuários que tem disponibilidade para executar a atividade. Utiliza a capacidade produtiva e o tempo de execução de uma atividade.',
  'filters.users': 'Usuários',
  'filters.users.description':
    'Aplica a pesquisa para todos os usuários, apenas nos usuários relacionados ou em usuários específicos.',
  'filters.all_users': 'Todos os usuários',
  'filters.related_users': 'Usuários relacionados',
  'filters.selected': 'Usuários específicos',
  distanceRadius: 'Distancia (km)',
  generalConfig: 'Configuração geral',
  'generalConfig.daysLimit': 'Limite de dias',
  'generalConfig.daysLimit.description':
    'Enquanto não encontrar usuários, procura no proximo dia até atingir o limite de dias.'
}

export default i18n
